const defaultState = {
    progress: 0,
    text: 'Er gaat iets fout! Probeer de pagina te verversen.',
    complete: false
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'GAMEPLAYER_LOADING_UPDATE_PROGRESS': {
            const { payload } = action;
            return {
                ...state,
                progress: payload.progress,
                text: payload.text
            };
        }
        case 'GAMEPLAYER_LOADING_SET_COMPLETE': {
            return {
                ...state,
                complete: action.payload
            };
        }
        default: {
            return state;
        }
    }
}
